import DOMPurify from "dompurify";

/**
 * Sanitize HTML content (from WYSIWYG editors like react-quill).
 * Strips dangerous tags/attributes while preserving safe formatting.
 */
export function sanitizeHtml(html) {
  if (!html) return "";
  const clean = html.replace(/&nbsp;/g, " ");
  return DOMPurify.sanitize(clean, {
    ADD_ATTR: [
      "target", "rel",
      "colspan", "rowspan", "data-row", "data-col", "data-rowspan", "data-colspan",
      "contenteditable",
      "data-callout",
      "allow", "allowfullscreen", "frameborder",
    ],
    ADD_TAGS: ["iframe", "table", "thead", "tbody", "tr", "td", "th", "colgroup", "col", "hr"],
    FORBID_TAGS: ["script", "style"],
  });
}

